import { stripFlavor } from '@pflegia/util/common/path-utils';

/**
 * The canonical URL should always be for the transparent job board page, not the anonymous one
 *
 * @param {string} path The current page path returned from router.asPath
 * @param {string} transparentPath The transparent path to use as the canonical URL
 * @returns The correct canonical URL
 */
const getCanonicalForTransparentPages = (path: string, transparentPath: string) => {
  const cleanPath = stripFlavor(path);
  if (cleanPath.startsWith(transparentPath)) return cleanPath;

  const pathSplitBySlash = cleanPath.slice(1).split('/');
  return [transparentPath, ...pathSplitBySlash.slice(1)].join('/');
};

export default getCanonicalForTransparentPages;
